import React from "react";
import Cookies from "js-cookie";

const TelegramLoginPage = () => {
    React.useEffect(() => {
        window.onTelegramAuth = function (user) {
            user.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            
            // Получаем реферальную ссылку из cookies
            const refId = Cookies.get("ref_id");
            if (refId) {
                user.ref = refId;
            }
            
            fetch('/api/auth/telegram', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            }).then(res => res.json()).then(data => {
                window.location.href = '/';
            });
        };

        // Динамически добавляем скрипт Telegram
        const script = document.createElement("script");
        script.src = "https://telegram.org/js/telegram-widget.js?7";
        script.async = true;
        script.setAttribute("data-telegram-login", "oncaspin_bot"); // замените на username вашего бота
        script.setAttribute("data-size", "large");
        script.setAttribute("data-userpic", "false");
        script.setAttribute("data-request-access", "write");
        script.setAttribute("data-onauth", "onTelegramAuth(user)");
        document.getElementById("telegram-login-widget").appendChild(script);

        // Очистка
        return () => {
            if (window.onTelegramAuth) delete window.onTelegramAuth;
            const widgetDiv = document.getElementById("telegram-login-widget");
            if (widgetDiv) widgetDiv.innerHTML = "";
        };
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
            <h2>Вход через Telegram</h2>
            <div id="telegram-login-widget"></div>
        </div>
    );
};

export default TelegramLoginPage; 